import Reveal from "@/components/site/Reveal";
import { ShieldCheck, HardHat, FirstAidKit, ClipboardText } from "@phosphor-icons/react";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Barrier Discipline",
    body: "Two verified barriers between the reservoir and the environment — always. No exceptions on pressure control.",
  },
  {
    icon: HardHat,
    title: "Certified Crews",
    body: "Every field engineer is trained, competency-assessed and offshore-survival certified before mobilization.",
  },
  {
    icon: ClipboardText,
    title: "Job Safety Analysis",
    body: "Every operation begins with a documented JSA and toolbox talk. Stop-work authority sits with every crew member.",
  },
  {
    icon: FirstAidKit,
    title: "Zero-Harm Target",
    body: "We plan for people to go home the way they arrived. Incident-free operations are the only acceptable outcome.",
  },
];

export default function Safety() {
  return (
    <section
      id="safety"
      className="relative bg-background border-b border-white/10 py-24 md:py-40"
      data-testid="safety-section"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <Reveal className="lg:col-span-5">
            <span className="mono-label text-primary">/ HSE</span>
            <h2 className="mt-6 font-display font-bold uppercase tracking-tight text-4xl md:text-6xl leading-[0.9]">
              Safety is the
              <span className="text-primary"> operation</span>
            </h2>
            <p className="mt-8 text-foreground/60 text-base md:text-lg leading-relaxed max-w-md">
              Wireline works at the sharp end of the well — under pressure, over water,
              around live sources. Our health, safety and environment system isn&apos;t a
              document on a shelf; it&apos;s how every job is run.
            </p>
          </Reveal>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 border-t border-l border-white/10">
            {PILLARS.map((p, i) => {
              const Icon = p.icon;
              return (
                <Reveal
                  key={p.title}
                  delay={i * 0.06}
                  className="border-b border-r border-white/10 p-8 group hover:bg-secondary/40 transition-colors duration-300"
                >
                  <Icon
                    size={36}
                    weight="light"
                    className="text-foreground/70 group-hover:text-primary transition-colors duration-300 mb-6"
                  />
                  <h3 className="font-display font-bold text-xl tracking-tight mb-3">
                    {p.title}
                  </h3>
                  <p className="text-foreground/55 text-sm leading-relaxed">{p.body}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
